export default class PayloadParameters {
  constructor ({ storeFilters, productFilters, productDimensions, storeDimensions, metrics, fact, sort, pivot, dateFilters, dateDimensions }) {
    this.store_filters = storeFilters
    this.product_filters = productFilters
    this.store_dimensions = storeDimensions
    this.product_dimensions = productDimensions
    this.metrics = metrics
    this.fact = fact
    this.sort = sort
    this.pivot = pivot
    this.date_filters = dateFilters
    this.date_dimensions = dateDimensions
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/PayloadParameters.js